<template>
  <section>
    <form
      id="register"
      v-on:submit.prevent="validateBeforeSubmit"
      :action="
        `${identityApi}/signup?redirectUrl=${this.redirectUrl}&lang=${$i18n.locale}`
      "
      method="post"
    >
      <b-field
        :label="$t('email.name')"
        :type="{ 'is-danger': errors.has('email') }"
        :message="errors.first('email')"
      >
        <b-input
          type="text"
          v-model="email"
          name="email"
          v-validate="'required|email'"
        />
      </b-field>

      <b-field
        :label="$t('password.name')"
        :type="{ 'is-danger': errors.has('password') }"
        :message="errors.first('password')"
      >
        <b-input
          type="password"
          v-model="password"
          name="password"
          v-validate="'required'"
          password-reveal
        />
      </b-field>

      <b-field
        label
        :type="{ 'is-danger': errors.has('flag-terms') }"
        :message="{
          'Please check this box to proceed': errors.firstByRule(
            'flag-terms',
            'required'
          )
        }"
      >
        <b-checkbox
          v-model="flagTerms"
          name="flag-terms"
          v-validate="'required:false'"
          >{{ $t("user.termsAndConditions") }}</b-checkbox
        >
      </b-field>
      <button
        :disabled="!flagTerms"
        type="submit"
        class="button is-primary is-rounded action-button"
      >
        {{ $t("user.register") }}
      </button>
    </form>
    <a class="read-terms" @click="goTo('/terms')">{{
      $t("user.readTermsAndConditions")
    }}</a>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import { goTo } from "../../mixins/goTo.js";

export default {
  data() {
    return {
      userName: null,
      email: null,
      password: null,
      flagTerms: false,
      redirectUrl: null
    };
  },
  mixins: [goTo],
  created() {
    this.identityApi = `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
      process.env.VUE_APP_IDENTITY_API
    }`;
    this.redirectUrl = window.location.href;
  },
  methods: {
    ...mapActions(["createUser"]),
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          document.getElementById("register").submit();
        } else {
          this.$buefy.toast.open({
            message: this.$("user.signUpNotValid"),
            type: "is-danger",
            position: "is-top-right"
          });
        }
      });
    }
  }
};
</script>
